export const parseStreamError = (error: string) => {
  const extractedObj = error.match(/\{.+\}/g)
  if (extractedObj) {
    const errorObject: StreamError = JSON.parse(extractedObj[0].replace(/'/g, '"'))
    return errorObject.error
  }
  return {
    message: "Something went wrong",
    type: "global_error"
  }
}
